var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTranslationstodatahub = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 132 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Order-translations-info-modal-mobile",
    transform: "translate(-121.000000, -1037.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(94.000000, 539.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "product-category-button-copy-7",
    transform: "translate(0.000000, 496.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-30",
    transform: "translate(27.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path-Copy",
    fillRule: "nonzero",
    points: "40.3137255 4 39.1111111 5.20261438 44.7843137 10.875817 28 10.875817 28 12.5490196 44.7843137 12.5490196 39.1111111 18.2222222 40.3137255 19.4248366 47.4248366 12.3137255 48 11.7124183 47.4248366 11.1111111"
  }), /*#__PURE__*/React.createElement("text", {
    id: "DataHub",
    fontFamily: "Avenir-Heavy, Avenir",
    fontSize: 18,
    fontWeight: 600,
    "line-spacing": 24
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 57,
    y: 18
  }, "DataHub")), /*#__PURE__*/React.createElement("path", {
    d: "M0,2 L0,17 L5,17 L5,22 L20,22 L20,7 L15,7 L15,2 L0,2 Z M1.64383562,3.64383562 L13.4246575,3.64383562 L13.4246575,7.48312133 L5.48312133,15.4246575 L1.64383562,15.4246575 L1.64383562,3.64383562 Z M6.02739726,5.28767123 L6.02739726,6.14003044 L3.56164384,6.14003044 L3.56164384,7.84474886 L7.61986301,7.84474886 C7.51391288,8.82363056 7.22495699,9.5960811 6.74657534,10.1354642 C6.4640411,10.0389081 6.21040219,9.91904511 6.00171233,9.7891933 C5.42380137,9.43293358 5.20547945,9.05336779 5.20547945,8.69710807 L3.56164384,8.69710807 C3.56164384,9.71261394 4.16523973,10.5583145 4.97431507,11.1210046 C4.56977781,11.210902 4.1010274,11.2541857 3.56164384,11.2541857 L3.56164384,12.9589041 C5.01926411,12.9589041 6.23287671,12.6126332 7.15753425,11.9733638 C7.58775726,12.0499431 8.0244011,12.1065449 8.49315068,12.1065449 L8.49315068,10.5083714 C8.93942658,9.73259154 9.17701178,8.82695988 9.26369863,7.84474886 L10.1369863,7.84474886 L10.1369863,6.14003044 L7.67123288,6.14003044 L7.67123288,5.28767123 L6.02739726,5.28767123 Z M14.5168787,8.57534247 L18.3561644,8.57534247 L18.3561644,20.3561644 L6.57534247,20.3561644 L6.57534247,16.5168787 L14.5168787,8.57534247 Z M13.4246575,10.2191781 L12.6541096,12.5972603 L11.010274,17.6147524 L10.9589041,17.7454162 L10.9589041,18.7123288 L12.6027397,18.7123288 L12.6027397,17.9806112 L12.6284247,17.8760801 L14.2208904,17.8760801 L14.2465753,17.9806112 L14.2465753,18.7123288 L15.890411,18.7123288 L15.890411,17.7454162 L15.8390411,17.6147524 L14.1952055,12.5972603 L13.4246575,10.2191781 Z M13.5616438,15.4760274 L13.7928082,16.1952055 L13.3304795,16.1952055 L13.5616438,15.4760274 Z",
    id: "Shape-Copy-4",
    fillRule: "nonzero"
  }))))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTranslationstodatahub);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/translationstodatahub.207e799b5cbb2d6d5f2afee0a8b22f03.svg";